import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedNumber } from "react-intl";
import { LabeledProperty } from "./LabeledProperty";
export function calculate(params) {
    let { price = 0, amount = 0, mvaPercentage = 0, allowedDeviation = 0 } = params;
    if (amount < allowedDeviation) {
        amount = 0;
    }
    const net = amount * price;
    const vat = (net * mvaPercentage) / 100;
    const gross = net + vat;
    return { net, vat, gross };
}
export const DistanceCalculation = ({ actual, planned, allowedDeviation, price, mvaPercentage, mileage }) => {
    let difference = actual - planned - mileage;
    const value = calculate({
        price,
        amount: difference,
        mvaPercentage,
        allowedDeviation
    });
    return (_jsxs(_Fragment, { children: [_jsx(LabeledProperty, { label: "Kostnad (netto)", overrideWidth: 12, value: _jsx(FormattedNumber, { format: "currency_full", value: value.net ? value.net : 0 }) }), _jsx(LabeledProperty, { label: "MVA", overrideWidth: 12, value: _jsx(FormattedNumber, { format: "currency_full", value: value.vat ? value.vat : 0 }) }), _jsx(LabeledProperty, { label: "Kostnad total (brutto)", overrideWidth: 12, value: _jsx(FormattedNumber, { format: "currency_full", value: value.gross ? value.gross : 0 }) })] }));
};
//# sourceMappingURL=DistanceCalculation.js.map